import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Typography } from 'antd';

import { Flex, Container } from '@/ui';
import { Text, Title } from '@/ui/typography';
import { useQuestionnaires } from '@/features/constructor/hooks';
import { useNavigate } from 'react-router';

export const QuestionnaireList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading } = useQuestionnaires();

  return (
    <>
      <Container $marginBottom={30}>
        <Title level={4}>{t('Questionnaires list')}</Title>
      </Container>

      {isLoading && <div>{t('Loading')}...</div>}

      {data?.map((questionnaire) => (
        <Card
          size='small'
          title={questionnaire.type}
          key={questionnaire.id}
          style={{ marginBottom: '10px' }}
          styles={{
            header: {
              fontWeight: 300,
              fontSize: '14px'
            }
          }}
        >
          <Flex vertical gap={8}>
            {questionnaire.name && <Typography.Text strong>{questionnaire.name}</Typography.Text>}
            <Text $fontSize={14}>{questionnaire.title}</Text>
          </Flex>

          <Container $marginTop={12}>
            <Button
              mode={'strong'}
              onClick={() => navigate(`/constructorQuestionnaires/${questionnaire.id}`)}
              type='primary'
            >
              Edit
            </Button>
          </Container>
        </Card>
      ))}
    </>
  );
};
